import type { Media } from "@mw/shared/payload-types";

import { appUrls } from "@/constants";
import { UseCase } from "@ui/components/languages/types";

export function getVoiceShareUrl(voice: { isVoiceLibraryVoice: boolean; voiceId: string }) {
  // Temporary fix while we do not have the one click add to my library feature for non voice library voices
  if (!voice.isVoiceLibraryVoice) return;
  const base = voice.isVoiceLibraryVoice ? appUrls.voiceLibrary : appUrls.copyVoiceFromInternalUser;
  const url = new URL(base);
  url.searchParams.set("voiceId", voice.voiceId);
  return url.toString();
}

export function getVoiceDesignUrl(prompt: string, seed?: null | string) {
  const url = new URL(appUrls.voiceDesign);
  url.searchParams.set("prompt", prompt);
  if (seed) {
    url.searchParams.set("seed", seed);
  }
  return url.toString();
}

export function getVoiceSearchUrl(prompt: string) {
  const url = new URL(appUrls.voiceLibrary);
  url.searchParams.set("search", prompt);
  return url.toString();
}

export const DEFAULT_VOICES_KEY = "";

export type Voice = {
  image: Media | string;
  imageFace?: Media | string;
  name: string;
  tags: { name: string }[];
  useCase?: UseCase;
  voiceId: string;
  category?: string;
  shortDescription?: string;
  link?: string;
  previewUrl?: string;
};

export const Tags = {
  News: { name: "News" },
  Narration: { name: "Narration" },
  Characters: { name: "Characters" },
  Conversational: { name: "Conversational" },
};

export const Voices = {
  Mai: {
    name: "Mai",
    tags: [],
    voiceId: "2vT8WlUXV1qBtgiLZdSb",
    image: "daniel.webp",
  },
  Nhung: {
    name: "Nhung",
    tags: [],
    voiceId: "jpmnSYDOADVEpZksbLmc",
    image: "charlie.webp",
  },
  Trung: {
    name: "Trung",
    tags: [],
    voiceId: "ueSxRO0nLF1bj93J2hVt",
    image: "charlotte.webp",
  },
  Ojaswi: {
    name: "Ojaswi",
    tags: [],
    voiceId: "3JDquces8E8bkmvbh6Bc",
    image: "sarah.webp",
  },
  Meera: { name: "Meera", tags: [], voiceId: "gCr8TeSJgJaeaIoV4RWH", image: "alice.webp" },
  Andrej: {
    name: "Andrej",
    tags: [],
    voiceId: "bYqmvVkXUBwLwYpGHGz3",
    image: "laura.webp",
  },
  Angela: {
    name: "Angela",
    tags: [],
    voiceId: "Pid5DJleNF2sxsuF6YKD",
    image: "callum.webp",
  },
  Slobodan: {
    name: "Slobodan",
    tags: [],
    voiceId: "adxhr4Ei7ASJ3Cz7fxwX",
    image: "daniel.webp",
  },
  Maja: {
    name: "Maja",
    tags: [],
    voiceId: "0jvpZ98RZwx5FBOSZAc3",
    image: "alice.webp",
  },
  Peter: {
    name: "Peter",
    tags: [],
    voiceId: "JCNhnuny412iVIvPSTD4",
    image: "charlotte.webp",
  },
  Julian: {
    name: "Julian",
    tags: [],
    voiceId: "kzrsjZhHCumKqmkJl486",
    image: "will.webp",
  },
  Hana: { name: "Hana", tags: [], voiceId: "2qbJHyAaz7tHCfVZS6z3", image: "charlie.webp" },
  Thomas: {
    name: "Thomas",
    tags: [],
    voiceId: "C43bq5qXRueL1cBQEOt3",
    image: "callum.webp",
  },
  Sissel: {
    name: "Sissel",
    tags: [],
    voiceId: "ZKutKtutnlbOxDxkNlhk",
    image: "lily.webp",
  },
  Mathias: {
    name: "Mathias",
    tags: [],
    voiceId: "ygiXC2Oa1BiHksD3WkJZ",
    image: "charlie.webp",
  },
  Ondrej: {
    name: "Ondřej",
    tags: [],
    voiceId: "nCmK9bolkZa2wzrAjnEe",
    image: "sarah.webp",
  },
  Marcus: {
    name: "Marcus",
    tags: [],
    voiceId: "0Taf9YpPJZOyehNCOJu1",
    image: "charlie.webp",
  },
  Petr: { name: "Petr", tags: [], voiceId: "NHv5TpkohJlOhwlTCzJk", image: "will.webp" },
  Kyriakos: {
    name: "Kyriakos ",
    tags: [],
    voiceId: "6z1Ks05MOtac6wYNh9PJ",
    image: "chris.webp",
  },
  Niki: {
    name: "Niki ",
    tags: [],
    voiceId: "AnNshXL08po8KEaf53gz",
    image: "charlotte.webp",
  },
  Fatsis: {
    name: "Fatsis",
    tags: [],
    voiceId: "cuab90umcstNgL8U7orz",
    image: "callum.webp",
  },
  Oleksii: {
    name: "Oleksii",
    tags: [],
    voiceId: "MajbwhPMg2mRJJCesMAF",
    image: "alice.webp",
  },
  Anton: {
    name: "Anton",
    tags: [],
    voiceId: "GVRiwBELe0czFUAJj0nX",
    image: "laura.webp",
  },
  Olena: {
    name: "Olena",
    tags: [],
    voiceId: "ARxhnQPZCfSLpMBASSii",
    image: "alice.webp",
  },
  Magyar: {
    name: "Magyar ",
    tags: [],
    voiceId: "TumdjBNWanlT3ysvclWh",
    image: "charlotte.webp",
  },
  Antonia: {
    name: "Antonia",
    tags: [],
    voiceId: "3z9q8Y7plHbvhDZehEII",
    image: "charlie.webp",
  },
  Corina: {
    name: "Corina",
    tags: [],
    voiceId: "gbLy9ep70G3JW53cTzFC",
    image: "laura.webp",
  },
  Jora: {
    name: "Jora",
    tags: [],
    voiceId: "OlBp4oyr3FBAGEAtJOnU",
    image: "alice.webp",
  },
  Tulipe: {
    name: "Tulipe",
    tags: [],
    voiceId: "ngiiW8FFLIdMew1cqwSB",
    image: "callum.webp",
  },
  Eva: {
    name: "Eva",
    tags: [],
    voiceId: "djUbJhnXETnX31p3rgun",
    image: "charlie.webp",
  },
  Sara: {
    name: "Sara",
    tags: [],
    voiceId: "KHCvMklQZZo0O30ERnVn",
    image: "sarah.webp",
  },
  Alexander: {
    name: "Alexander ",
    tags: [],
    voiceId: "UPeEHhD60Z9Djsbwmmy4",
    image: "charlotte.webp",
  },
  Anders: {
    name: "Anders",
    tags: [],
    voiceId: "x0u3EW21dbrORJzOq1m9",
    image: "alice.webp",
  },
  Sofie: {
    name: "Sofie",
    tags: [],
    voiceId: "4xkUqaR9MYOJHoaC1Nak",
    image: "callum.webp",
  },
  Johannes: {
    name: "Johannes",
    tags: [],
    voiceId: "2dhHLsmg0MVma2t041qT",
    image: "laura.webp",
  },
  Jonas: {
    name: "Jonas",
    tags: [],
    voiceId: "e6OiUVixGLmvtdn2GJYE",
    image: "laura.webp",
  },
  Adam: {
    name: "Adam",
    tags: [],
    voiceId: "x0u3EW21dbrORJzOq1m9",
    image: "alice.webp",
  },
  Sanna: {
    name: "Sanna ",
    tags: [],
    voiceId: "aSLKtNoVBZlxQEMsnGL2",
    image: "chris.webp",
  },
  Pawel: {
    name: "Pawel",
    tags: [],
    voiceId: "zzBTsLBFM6AOJtkr1e9b",
    image: "george.webp",
  },
  Aneta: { name: "Aneta", tags: [], voiceId: "Pid5DJleNF2sxsuF6YKD", image: "will.webp" },
  Damian: {
    name: "Damian",
    tags: [],
    voiceId: "S1JKkpuAQNsowB8ZvKRO",
    image: "jessica.webp",
  },
  Cavit: {
    name: "Cavit",
    tags: [],
    voiceId: "Y2T2O1csKPgWgyuKcU0a",
    image: "laura.webp",
  },
  Eda: { name: "Eda", tags: [], voiceId: "mBUB5zYuPwfVE6DTcEjf", image: "chris.webp" },
  Cem: {
    name: "Cem",
    tags: [],
    voiceId: "D1xRw7f8ZHedI7xJgfvz",
    image: "callum.webp",
  },
  Johan: {
    name: "Johan ",
    tags: [],
    voiceId: "AVIlLDn2TVmdaDycgbo3",
    image: "charlotte.webp",
  },
  Peeters: {
    name: "Peeters",
    tags: [],
    voiceId: "gC9jy9VUxaXAswovchvQ",
    image: "alice.webp",
  },
  Ruth: { name: "Ruth", tags: [], voiceId: "YUdpWWny7k5yb4QCeweX", image: "alice.webp" },
  Luca: {
    name: "Luca",
    tags: [],
    voiceId: "UlwxMDtxqMDYmG6pk2q6",
    image: "sarah.webp",
  },
  Linda: {
    name: "Linda",
    tags: [],
    voiceId: "3DPhHWXDY263XJ1d2EPN",
    image: "lily.webp",
  },
  Giovanni: {
    name: "Giovanni",
    tags: [],
    voiceId: "fzDFBB4mgvMlL36gPXcz",
    image: "will.webp",
  },
  Suara: {
    name: "Suara",
    tags: [],
    voiceId: "4RK3Moe6TpBQ4otXBFtc",
    image: "charlie.webp",
  },
  Andra: {
    name: "Andra",
    tags: [],
    voiceId: "gP7FRCgEZ8Lr3rnyGgpw",
    image: "alice.webp",
  },
  Tri: {
    name: "Tri ",
    tags: [],
    voiceId: "lFjzhZHq0NwTRiu2GQxy",
    image: "charlotte.webp",
  },
  Bo: { name: "Bo", tags: [], voiceId: "ZZ4xhVcc83kZBfNIlIIz", image: "daniel.webp" },
  Hyuk: {
    name: "Hyuk",
    tags: [],
    voiceId: "ZJCNdZEjYwkOElxugmW2",
    image: "alice.webp",
  },
  Felix: {
    name: "Felix",
    tags: [],
    voiceId: "sRk0zCqhS2Cmv0bzx5wA",
    image: "alice.webp",
  },
  Mintimer: {
    name: "Mintimer",
    tags: [],
    voiceId: " Dvfxihpdb69LFIkmih0k",
    image: "jessica.webp",
  },
  Artem: {
    name: "Artem",
    tags: [],
    voiceId: "blxHPCXhpXOsc7mCKk0P",
    image: "callum.webp",
  },
  Hamid: {
    name: "Hamid",
    tags: [],
    voiceId: "A9ATTqUUQ6GHu0coCz8t",
    image: "chris.webp",
  },
  Hmida: {
    name: "Hmida",
    tags: [],
    voiceId: "JjTirzdD7T3GMLkwdd3a",
    image: "charlie.webp",
  },
  Geza: { name: "Géza", tags: [], voiceId: "372NsdHr6qutUh2JE8DJ", image: "lily.webp" },
  Sana: {
    name: "Sana",
    tags: [],
    voiceId: "mRdG9GYEjJmIzqbYTidv",
    image: "chris.webp",
  },
  Kozy: {
    name: "Kozy",
    tags: [],
    voiceId: "RBnMinrYKeccY3vaUxlZ",
    image: "will.webp",
  },
  Sakura: {
    name: "Sakura",
    tags: [],
    voiceId: "RBnMinrYKeccY3vaUxlZ",
    image: "callum.webp",
  },
  Otani: {
    name: "Otani",
    tags: [],
    voiceId: "3JDquces8E8bkmvbh6Bc",
    image: "sarah.webp",
  },
  Niander: {
    name: "Niander",
    tags: [],
    voiceId: "bAFkvitDGeDMmqo9gJzO",
    image: "alice.webp",
  },
  Mila: {
    name: "Mila",
    tags: [],
    voiceId: "dCnu06FiOZma2KVNUoPZ",
    image: "jessica.webp",
  },
  Emilia: { name: "Emilia", tags: [], voiceId: "Dt2jDzhoZC0pZw5bmy2S", image: "will.webp" },
  Martin: {
    name: "Martin",
    tags: [],
    voiceId: "FNOttooGMYDRXmqkQ0Fz",
    image: "sarah.webp",
  },
  Claire: {
    name: "Claire",
    tags: [],
    voiceId: "6vTyAgAT8PncODBcLjRf",
    image: "charlie.webp",
  },
  Nicolas: {
    name: "Nicolas",
    tags: [],
    voiceId: "aQROLel5sQbj1vuIVi6B",
    image: "charlotte.webp",
  },
  Eleguar: {
    name: "Eleguar",
    tags: [],
    voiceId: "T7QGPtToiqH4S8VlIkMJ",
    image: "laura.webp",
  },
  Valeria: {
    name: "Valeria",
    tags: [],
    voiceId: "9oPKasc15pfAbMr7N6Gs",
    image: "daniel.webp",
  },
  Dan: { name: "Dan", tags: [], voiceId: "9F4C8ztpNUmXkdDDbz3J", image: "chris.webp" },
  Coco: { name: "Coco", tags: [], voiceId: "WuLq5z7nEcrhppO0ZQJw", image: "george.webp" },
  MartinLi: {
    name: "Martin Li",
    tags: [],
    voiceId: "WuLq5z7nEcrhppO0ZQJw",
    image: "brian.webp",
  },
  Liang: {
    name: "Liang",
    tags: [],
    voiceId: "FjfxJryh105iTLL4ktHB",
    image: "bill.webp",
  },
  Keren: {
    name: "Keren",
    tags: [],
    voiceId: "33B4UnXyTNbgLmdEDh5P",
    image: "eric.webp",
  },
  Adriano: {
    name: "Adriano",
    tags: [],
    voiceId: "hwnuNyWkl9DjdTFykrN6",
    image: "matilda.webp",
  },
  Monika: {
    name: "Monika",
    tags: [],
    voiceId: "1qEiC6qsybMkmnNdVMbK",
    image: "sarah.webp",
  },
  Raju: {
    name: "Raju",
    tags: [],
    voiceId: "zT03pEAEi0VHKciJODfn",
    image: "jessica.webp",
  },
  Will: {
    name: "Will",
    tags: [],
    voiceId: "bIHbv24MWmeRgasZH58o",
    image: "will.webp",
    useCase: UseCase.CUSTOMER_SUPPORT,
  },
  Jessica: {
    name: "Jessica",
    tags: [],
    voiceId: "cgSgspJ2msm6clMCkdW9",
    image: "jessica.webp",
  },
  Laura: {
    name: "Laura",
    tags: [],
    voiceId: "FGY2WhTYpPnrIDTdsKH5",
    image: "laura.webp",
  },
  Eric: {
    name: "Eric",
    tags: [],
    voiceId: "cjVigY5qzO86Huf0OWal",
    image: "eric.webp",
  },
  Sarah: {
    name: "Sarah",
    tags: [Tags.News],
    voiceId: "EXAVITQu4vr4xnSDxMaL",
    image: "sarah.webp",
    imageFace: "sarah.webp",
  },
  Matilda: {
    name: "Matilda",
    tags: [Tags.Narration],
    voiceId: "XrExE9yKIg1WjnnlVkGX",
    image: "matilda.webp",
    imageFace: "matilda.webp",
  },
  Lily: {
    name: "Lily",
    tags: [Tags.Narration],
    voiceId: "pFZP5JQG7iQjIQuC4Bku",
    image: "lily.webp",
    imageFace: "lily.webp",
  },
  Liam: {
    name: "Liam",
    tags: [Tags.Narration],
    voiceId: "TX3LPaxmHKxFdv7VOQHJ",
    image: "liam.webp",
    imageFace: "liam.webp",
  },
  George: {
    name: "George",
    tags: [Tags.Narration],
    voiceId: "JBFqnCBsd6RMkjVDRZzb",
    useCase: UseCase.DIFFERENT_LANGUAGE,
    image: "george.webp",
    imageFace: "george.webp",
  },
  Daniel: {
    name: "Daniel",
    tags: [Tags.News],
    voiceId: "onwK4e9ZLuTAKqWW03F9",
    useCase: UseCase.NARRATION,
    image: "daniel.webp",
    imageFace: "daniel.webp",
  },
  Chris: {
    name: "Chris",
    tags: [Tags.Conversational],
    voiceId: "iP95p4xoKVk53GoZ742B",
    useCase: UseCase.JOKE,
    image: "chris.webp",
    imageFace: "chris.webp",
  },
  Charlotte: {
    name: "Charlotte",
    tags: [Tags.Characters],
    useCase: UseCase.DIRECT_A_MOVIE,
    voiceId: "XB0fDUnXU5powFXDhCwa",
    image: "charlotte.webp",
    imageFace: "charlotte.webp",
  },
  Charlie: {
    name: "Charlie",
    tags: [Tags.Conversational],
    voiceId: "IKne3meq5aSn9XLyUdCD",
    image: "charlie.webp",
    imageFace: "charlie.webp",
  },
  Callum: {
    name: "Callum",
    tags: [Tags.Characters],
    voiceId: "N2lVS1w4EtoT3dr4eOWO",
    image: "callum.webp",
    imageFace: "callum.webp",
  },
  Alice: {
    name: "Alice",
    tags: [Tags.News],
    voiceId: "Xb7hH8MSUJpSbSDYk0k2",
    useCase: UseCase.VIDEO_VOICEOVER,
    image: "alice.webp",
    imageFace: "alice.webp",
  },
  Bill: {
    name: "Bill",
    tags: [Tags.Narration],
    voiceId: "pqHfZKP75CvOlQylNhV4",
    image: "bill.webp",
    imageFace: "bill.webp",
  },
  Brian: {
    name: "Brian",
    tags: [Tags.Narration],
    voiceId: "nPczCjzI2devNBz1zQrb",
    image: "brian.webp",
    imageFace: "brian.webp",
  },
  River: {
    name: "River",
    voiceId: "SAz9YHcvj6GT2YYXdXww",
    image: "river.webp",
    tags: [],
  },
  Aria: {
    name: "Aria",
    voiceId: "9BWtsMINqrJLrRacOk9x",
    image: "aria.webp",
    tags: [],
  },
  Roger: {
    name: "Roger",
    voiceId: "CwhRBWXzGAHq8TQ4Fs17",
    image: "roger.webp",
    tags: [],
  },
  Samara: {
    name: "Samara",
    voiceId: "19STyYD15bswVz51nqLf",
    image: "gray.webp",
    tags: [],
  },
  Announcer: {
    name: "Announcer",
    voiceId: "gU0LNdkMOQCOrPrwtbee",
    image: "green.webp",
    tags: [],
  },
  Sergeant: {
    name: "Sergeant",
    voiceId: "DGzg6RaUqxGRTHSBjfgF",
    image: "purple.webp",
    tags: [],
  },
  Spuds: {
    name: "Spuds",
    voiceId: "NOpBlnGInO9m6vDvFkFC",
    image: "darkblue.webp",
    tags: [],
  },
  Eve: {
    name: "Eve",
    voiceId: "BZgkqPqms7Kj9ulSkVzn",
    image: "orangepink.webp",
    tags: [],
  },
  Terry: {
    name: "Terry",
    voiceId: "wo6udizrrtpIxWGp2qJk",
    image: "purpleblue.webp",
    tags: [],
  },
};

export const LOCALE_TO_VOICES: { [key: string]: Voice[] } = {
  en: [
    Voices.Jessica,
    Voices.Brian,
    Voices.Alice,
    Voices.Bill,
    Voices.Callum,
    Voices.Charlie,
    Voices.Charlotte,
    Voices.Chris,
    Voices.Daniel,
    Voices.Eric,
    Voices.George,
    Voices.Laura,
    Voices.Liam,
    Voices.Lily,
    Voices.Matilda,
    Voices.Sarah,
    Voices.Will,
    Voices.Samara,
    Voices.Announcer,
    Voices.Eve,
    Voices.Terry,
    Voices.Sergeant,
    Voices.Spuds,
  ],
  it: [Voices.Alice, Voices.Lily, Voices.Matilda, Voices.River],
  fr: [
    Voices.Alice,
    Voices.Aria,
    Voices.Jessica,
    Voices.Laura,
    Voices.Matilda,
    Voices.Sarah,
    Voices.Bill,
    Voices.Callum,
    Voices.Chris,
    Voices.Eric,
    Voices.George,
    Voices.Roger,
    Voices.Will,
    Voices.River,
    Voices.Samara,
    Voices.Announcer,
    Voices.Eve,
    Voices.Terry,
    Voices.Sergeant,
    Voices.Spuds,
  ],
  ar: [
    Voices.Alice,
    Voices.Charlotte,
    Voices.Jessica,
    Voices.Laura,
    Voices.Matilda,
    Voices.Sarah,
    Voices.Bill,
    Voices.Brian,
    Voices.Chris,
    Voices.George,
  ],
  jp: [Voices.Alice, Voices.Jessica, Voices.George],
  vi: [Voices.Alice, Voices.Liam],
  zh: [
    Voices.Aria,
    Voices.Charlotte,
    Voices.Jessica,
    Voices.Laura,
    Voices.Lily,
    Voices.Sarah,
    Voices.Bill,
    Voices.Brian,
    Voices.Charlie,
    Voices.Will,
    Voices.River,
  ],
  cs: [Voices.Charlotte, Voices.Jessica, Voices.Lily, Voices.Bill, Voices.George, Voices.Liam, Voices.Will],
  de: [
    Voices.Jessica,
    Voices.Laura,
    Voices.Lily,
    Voices.Matilda,
    Voices.Bill,
    Voices.Brian,
    Voices.Daniel,
    Voices.Eric,
    Voices.Liam,
    Voices.Roger,
    Voices.Will,
    Voices.Samara,
    Voices.Announcer,
    Voices.Eve,
    Voices.Terry,
    Voices.Sergeant,
    Voices.Spuds,
  ],
  nl: [Voices.Lily, Voices.Brian, Voices.Roger],
  es: [Voices.Sarah, Voices.River, Voices.George, Voices.Eric, Voices.Matilda, Voices.Lily, Voices.Brian, Voices.Aria],
  hu: [Voices.Sarah, Voices.Eric], // Missing
  pt: [Voices.Brian, Voices.Charlie, Voices.Chris, Voices.Eric, Voices.Liam, Voices.Will, Voices.River],
  sk: [Voices.Brian, Voices.Eric, Voices.Will],
  tl: [Voices.Charlie, Voices.George, Voices.Will], // Missing
  [DEFAULT_VOICES_KEY]: [
    Voices.Alice,
    Voices.Jessica,
    Voices.Laura,
    Voices.Lily,
    Voices.Matilda,
    Voices.Sarah,
    Voices.Bill,
    Voices.Brian,
    Voices.Eric,
    Voices.George,
    Voices.Liam,
    Voices.Will,
    Voices.River,
    Voices.Samara,
    Voices.Announcer,
    Voices.Eve,
    Voices.Terry,
    Voices.Sergeant,
    Voices.Spuds,
  ],
};
